// Used for exhaustiveness checking in switch or if statements
export const assertNever = (value: never): never => {
  throw new Error(`Unexpected value: ${value}`);
};
